import React, { useEffect, useMemo, useRef } from "react";
import "./page-witch-menu.scss";
import { useTranslation } from "react-i18next";
import ShowContainer from "../ShowContainer";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "../error_boundary/ErrorBoundary";
import { setPageWitchMenuHeight } from "../../../store/siteSlice";
import useColor from "../../../hooks/other/useColor";
import AsideMenu from "../../landing/menu/AsideMenu";
import { useDebounceCallback } from "usehooks-ts";
import { useLocation } from "react-router-dom";

export default function PageWitchMenu({ className, children }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMenuAbsolute = useSelector((state) => state.deviceSize.isMenuAbsolute);
  const pageContentRef = useRef(null);
  const { bodyStyle } = useColor();

  const location = useLocation();
  const pathname = useMemo(() => location.pathname, [location]);

  const setPageHeightDebounce = useDebounceCallback(
    (val) => dispatch(setPageWitchMenuHeight(val)),
    300
  );

  useEffect(() => {
    dispatch(setPageWitchMenuHeight(window.innerHeight));

    const pageContent = pageContentRef.current;

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        requestAnimationFrame(() => {
          const clientHeight = entry.target.clientHeight;
          setPageHeightDebounce(clientHeight);
        });
      });
    });

    if (pageContent) {
      resizeObserver.observe(pageContent);
    }

    return () => {
      resizeObserver.disconnect();
      dispatch(setPageWitchMenuHeight(window.innerHeight));
    };
  }, [pathname]);

  return (
    <main style={bodyStyle} className={`page-witch-menu ${className} ${t("currentLang")}`}>
      <ShowContainer condition={!isMenuAbsolute}>
        <ErrorBoundary>
          <AsideMenu className="page-witch-menu__aside" />
        </ErrorBoundary>
      </ShowContainer>
      <ErrorBoundary>
        <div className="page-witch-menu__content" ref={pageContentRef}>
          {children}
        </div>
      </ErrorBoundary>
    </main>
  );
}
